import React from 'react';

export default function HotelCommission() {
  return (
    <div>HotelCommission</div>
  )
}
